// extracted by mini-css-extract-plugin
export default {"wrapper":"TopUpSalary_wrapper__l7iKw","text":"TopUpSalary_text__pR6xX"};